import { css } from '@emotion/core'

export const hiddenInput = css`
  position: absolute;
  height: 0;
  width: 0;
  padding: 0;
  border: none;
`
